import axios from "axios";
import { del, get, post, put, patch } from "./roles_api_helper";
import * as url from "./roles_url_helper";





// get series categories
export const getRoles = () => get(url.GET_ROLES);


// add serie categories
export const addNewRole = role => post(url.ADD_NEW_ROLE, role);

// update series categories
//export const updateRole = role => put(url.UPDATE_ROLE, role);
export const updateRole = role => patch(`${url.UPDATE_ROLE}/${role.uid}`, role);

// delete series categories
//export const deleteRole = role => del(url.DELETE_ROLE, { headers: { role } });
export const deleteRole = role => del(`${url.DELETE_ROLE}/${role}`);







export {
  //getLoggedInUser,
  
  
};
